import { QueryClient } from '@tanstack/react-query';

import { apiHatasiMi } from './hata';

/**
 * TANSTACK QUERY YAPILANDIRMASI.
 *
 * VARSAYILAN YENİDEN DENEME KAPALIYA YAKIN TUTULDU. Kütüphane varsayılanı
 * 3 kez dener ve bu, yetki hatalarında zararlıdır: 403 alan bir istek üç kez
 * daha gönderilir, sunucuda üç KVKK denetim kaydı daha oluşur ve kullanıcı
 * hatayı üç kat gecikmeyle görür.
 *
 * 401 buraya YALNIZ yenileme de başarısız olduğunda ulaşır — o noktada
 * oturum zaten düşürülmüştür ve tekrar denemek anlamsızdır. 4xx dalı bunu
 * da kapsar; ayrı bir kural gerekmez. Tekrar denenen tek şey ağ kopması
 * ve 5xx'tir.
 */
export function sorguIstemcisiOlustur(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        // Puantaj ve plan verisi sık değişir; 30 sn taze sayılır.
        staleTime: 30_000,
        refetchOnWindowFocus: false,
        retry: (denemeSayisi, hata) => {
          if (!apiHatasiMi(hata)) return false;

          // İstemci hatası tekrar denemeyle düzelmez.
          if (hata.durum >= 400 && hata.durum < 500) return false;

          return denemeSayisi < 2;
        },
      },
      mutations: {
        // Yazma işlemleri ASLA otomatik tekrarlanmaz: sunucuya ulaşmış ama
        // yanıtı kaybolmuş bir istek tekrarlanırsa çift kayıt oluşur.
        retry: false,
      },
    },
  });
}
